import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UltimateGenerateRequestPromptLanguageEnum } from '@models/Sessions/Idea/podcast-api';
import { MenuItem } from 'primeng/api';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SelectModule } from 'primeng/select';

import { promptLanguages } from '../../../../domain/prompt-language';

const getOptions = (): MenuItem[] => {
  return Object.values(UltimateGenerateRequestPromptLanguageEnum).map(lang => ({
    name: promptLanguages[lang].label,
    value: lang,
  }));
};

@Component({
  selector: 'app-prompt-language-picker',
  standalone: true,
  imports: [FloatLabelModule, SelectModule, FormsModule],
  templateUrl: './prompt-language-picker.component.html',
  styleUrl: './prompt-language-picker.component.scss',
})
export class PromptLanguagePickerComponent implements OnInit {
  options: MenuItem[] | undefined;

  @Input() disabled = false;
  @Input() value: UltimateGenerateRequestPromptLanguageEnum;
  @Output() valueChange =
    new EventEmitter<UltimateGenerateRequestPromptLanguageEnum>();

  get label() {
    return promptLanguages[this.value].label;
  }

  onValueChange(newValue: UltimateGenerateRequestPromptLanguageEnum) {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }

  ngOnInit() {
    this.options = getOptions();
  }
}
